import styled from "@emotion/styled";
import { color as colorFn } from "@smartsheet/design-tokens-react";
import Lottie from "lottie-react";
import React, { useEffect, useState } from "react";
import { SPINNER_CONTAINER_SIZES_MAP } from "./constants";
import ursaSpinner from "./lottie_files/ursa_spinner.json";
import { SpinnerProps, SpinnerSizes } from "./types";

export const Spinner: React.FC<SpinnerProps> = ({ clientId, color, initialDelay, size = "medium", ...rest }) => {
    const [visible, setVisible] = useState(initialDelay === undefined);
    useEffect(() => {
        if (initialDelay) {
            const timer = setTimeout(() => {
                setVisible(true);
            }, initialDelay);

            return () => {
                clearTimeout(timer);
            };
        }
    }, [initialDelay]);
    return (
        <Container size={size} color={color} {...rest} data-client-id={clientId}>
            {/* We reserve the space with the container and then fade the visible pieces in. */}
            {visible && <Lottie animationData={ursaSpinner} />}
        </Container>
    );
};

interface ContainerProps {
    color: string | undefined;
    size: SpinnerSizes;
}

const Container = styled("div")<ContainerProps>`
    box-sizing: border-box;
    display: block;
    color: ${({ color }) => (color ? color : colorFn("color--background--primary--strong"))};
    path {
        stroke: currentColor;
    }
    font-size: 0;
    height: ${({ size }) => SPINNER_CONTAINER_SIZES_MAP[size]}px;
    width: ${({ size }) => SPINNER_CONTAINER_SIZES_MAP[size]}px;
    position: relative;
    pointer-events: none;
`;
